import { render, staticRenderFns } from "./Chart_FFT.vue?vue&type=template&id=8babbfb2&scoped=true"
import script from "./Chart_FFT.vue?vue&type=script&lang=js"
export * from "./Chart_FFT.vue?vue&type=script&lang=js"
import style0 from "./Chart_FFT.vue?vue&type=style&index=0&id=8babbfb2&prod&lang=css"
import style1 from "./Chart_FFT.vue?vue&type=style&index=1&id=8babbfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8babbfb2",
  null
  
)

export default component.exports